import React from 'react'
import "../styles/FooterStyle.css"

const Footer = () => {
  return (
    <div style={{width : "100%"}} id='Footer'>
        <h1>Made By</h1>
        <img src="dev.png" alt="Developers" id='dev'/>
    </div>
  )
}

export default Footer